// extracted by mini-css-extract-plugin
export default {"block":"Video_block__E3G3q","header":"Video_header__A11sT","box":"Video_box__vmx8d","text":"Video_text__pXdLz","video":"Video_video__yhxIr"};